/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Player_Stats_GamesInputs */

const th_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`บันทึกแล้ว ${i?.n} เกม`)
};

const en_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} games recorded`)
};

const ja_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 試合を記録`)
};

const zh_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已记录 ${i?.n} 场比赛`)
};

const es_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} partidos registrados`)
};

const pt_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} jogos registrados`)
};

const id_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} pertandingan tercatat`)
};

const fr_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} matchs relevés`)
};

const tl_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} larong naitala`)
};

const vi_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã ghi nhận ${i?.n} trận`)
};

const ko_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}경기 기록`)
};

const de_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} Spiele erfasst`)
};

const ru_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Матчей записано: ${i?.n}`)
};

const tr_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} maç kaydedildi`)
};

const it_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} partite registrate`)
};

const pl_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zapisanych meczów: ${i?.n}`)
};

const uk_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Записано матчів: ${i?.n}`)
};

const hi_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} मैच दर्ज`)
};

const ar_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} مباريات مسجَّلة`)
};

const ms_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} perlawanan direkodkan`)
};

const bn_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}টি খেলা নথিভুক্ত`)
};

const zh_tw2_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已記錄 ${i?.n} 場比賽`)
};

const zh_hk2_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已記錄 ${i?.n} 場比賽`)
};

const ur_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} میچ درج`)
};

const fa_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} بازی ثبت شده`)
};

const sw_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Michezo ${i?.n} imerekodiwa`)
};

const nl_player_stats_games = /** @type {(inputs: Player_Stats_GamesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} wedstrijden vastgelegd`)
};

/**
* | output |
* | --- |
* | "{n} games recorded" |
*
* @param {Player_Stats_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_stats_games = /** @type {((inputs: Player_Stats_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Stats_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_stats_games(inputs)
	if (locale === "ja") return ja_player_stats_games(inputs)
	if (locale === "zh") return zh_player_stats_games(inputs)
	if (locale === "es") return es_player_stats_games(inputs)
	if (locale === "pt") return pt_player_stats_games(inputs)
	if (locale === "id") return id_player_stats_games(inputs)
	if (locale === "fr") return fr_player_stats_games(inputs)
	if (locale === "tl") return tl_player_stats_games(inputs)
	if (locale === "vi") return vi_player_stats_games(inputs)
	if (locale === "ko") return ko_player_stats_games(inputs)
	if (locale === "de") return de_player_stats_games(inputs)
	if (locale === "ru") return ru_player_stats_games(inputs)
	if (locale === "tr") return tr_player_stats_games(inputs)
	if (locale === "it") return it_player_stats_games(inputs)
	if (locale === "pl") return pl_player_stats_games(inputs)
	if (locale === "uk") return uk_player_stats_games(inputs)
	if (locale === "hi") return hi_player_stats_games(inputs)
	if (locale === "ar") return ar_player_stats_games(inputs)
	if (locale === "ms") return ms_player_stats_games(inputs)
	if (locale === "bn") return bn_player_stats_games(inputs)
	if (locale === "zh-TW") return zh_tw2_player_stats_games(inputs)
	if (locale === "zh-HK") return zh_hk2_player_stats_games(inputs)
	if (locale === "ur") return ur_player_stats_games(inputs)
	if (locale === "fa") return fa_player_stats_games(inputs)
	if (locale === "sw") return sw_player_stats_games(inputs)
	if (locale === "nl") return nl_player_stats_games(inputs)
	return en_player_stats_games(inputs)
});